export default {
  setCurrency: (state, store, code) => {
    state.currency.code = code;

    //Save it
    store.currency_code = code;
  }
}